module.exports = __webpack_public_path__ + "static/media/S-task11_nodeLink.0ae4a7e8.png";